// extracted by mini-css-extract-plugin
export var columnList = "_bb-0";